import React from 'react';
import './RecordingIndicator.css';

export interface RecordingIndicatorProps {
  /** Whether recording is currently active */
  isRecording: boolean;
  /** Optional additional CSS class */
  className?: string;
}

/**
 * Visual recording indicator component
 * Shows a pulsing red dot when recording is active
 * Updates to inactive state when recording stops
 */
export const RecordingIndicator: React.FC<RecordingIndicatorProps> = ({
  isRecording,
  className = '',
}) => {
  const containerClass = [
    'recording-indicator',
    isRecording ? 'recording-indicator--active' : 'recording-indicator--inactive',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClass} role="status" aria-live="polite">
      <div className="recording-indicator__dot" aria-hidden="true" />
      <span className="recording-indicator__text">
        {isRecording ? 'Recording...' : 'Not Recording'}
      </span>
    </div>
  );
};